import React, { useEffect, useState } from 'react';
import { useInView } from '../../../hooks/useInView';

function Counter({ target, suffix = '', prefix = '' }: { target: number; suffix?: string; prefix?: string }) {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView(0.3);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 1800;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [inView, target]);

  return (
    <span ref={ref as React.RefObject<HTMLSpanElement>}>
      {prefix}{count.toLocaleString()}{suffix}
    </span>
  );
}

const STATS = [
  { display: <Counter target={3000} suffix="+" />, label: 'local business categories covered' },
  { display: <span>1</span>, label: 'credit per company, all contacts included' },
  { display: <Counter target={30} />, label: 'day auto data deletion, GDPR clean' },
  { display: <Counter target={5} />, label: 'leadership titles searchable per query' },
];

export default function LogoStrip() {
  const { ref, inView } = useInView(0.15);

  return (
    <div ref={ref as React.RefObject<HTMLDivElement>} className="bg-white py-20 sm:py-28 border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        <p
          className="text-center text-[11px] font-black uppercase tracking-[0.18em] text-slate-400 mb-14"
          style={{ opacity: inView ? 1 : 0, transition: 'opacity 0.5s ease' }}
        >
          By the numbers
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {STATS.map((s, i) => (
            <div
              key={i}
              className="flex flex-col items-center text-center group"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(24px)',
                transition: `opacity 0.6s ease ${i * 100}ms, transform 0.6s ease ${i * 100}ms`,
              }}
            >
              {/* big yellow number box */}
              <div className="bg-brand-500 rounded-2xl px-6 py-5 mb-5 w-full max-w-[220px] group-hover:bg-brand-400 group-hover:scale-105 transition-all duration-300 shadow-lg shadow-brand-500/20">
                <div className="text-[1.6rem] sm:text-[2.6rem] font-black text-slate-900 leading-none tabular-nums">
                  {s.display}
                </div>
              </div>
              <p className="text-[13px] text-slate-500 font-medium leading-snug max-w-[130px]">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
